var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c("div", { staticClass: "bg-surface-secondary w-100" }, [
      _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
        _c("div", { staticClass: "container-fluid py-3" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                _c("div", [
                  _c("button", {
                    staticClass: "btn-close text-xs",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vr opacity-20 my-1" }),
                _vm._v(" "),
                _c("div", [
                  _c("h1", { staticClass: "h4 ls-tight" }, [
                    _vm._v(
                      "Paquete - " + _vm._s(_vm.data.type) + _vm._s(_vm.data.id)
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "text-sm text-muted mb-0" },
                    [
                      _vm._v(
                        "Tu paquete con la descripción\n                                    "
                      ),
                      _c(
                        "v-tooltip",
                        {
                          staticClass: "mx-1",
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  Array.isArray(_vm.data.description)
                                    ? _c(
                                        "b",
                                        _vm._g(
                                          _vm._b(
                                            { staticClass: "nowrap" },
                                            "b",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(_vm.data.description[0]) +
                                              " ...\n                                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "small",
                            _vm._l(
                              _vm.data.description,
                              function (description, key) {
                                return _c("div", { key: key }, [
                                  _vm._v(_vm._s(description)),
                                ])
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                      _vm._v(
                        "\n                                se encuentra en estado: "
                      ),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.data.state ? _vm.data.state.name : "")
                        ),
                      ]),
                      _vm._v("."),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
        _c("div", { staticClass: "container-fluid vstack gap-5" }, [
          _vm.loading
            ? _c("div", { staticClass: "w-100 pt-5" }, [
                _c("div", { staticClass: "text-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "spinner-border text-primary",
                      attrs: { role: "status" },
                    },
                    [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Loading..."),
                      ]),
                    ]
                  ),
                ]),
              ])
            : _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group mb-2 d-flex align-items-center",
                    },
                    [
                      _c(
                        "small",
                        {
                          staticClass: "input-title",
                          staticStyle: { width: "140px" },
                        },
                        [_vm._v("Valor: ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ml-2",
                          staticStyle: { width: "calc(100% - 140px)" },
                        },
                        [
                          _c("input", {
                            staticClass:
                              "form-control form-control-sm text-muted bg-white",
                            staticStyle: {
                              "font-size": "11px",
                              height: "31px",
                              display: "flex",
                              "align-items": "center",
                            },
                            attrs: { type: "text", readonly: "" },
                            domProps: {
                              value: Number(_vm.data.value || 0).toFixed(2),
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group mb-2 d-flex align-items-center",
                    },
                    [
                      _c(
                        "small",
                        {
                          staticClass: "input-title",
                          staticStyle: { width: "140px" },
                        },
                        [_vm._v("Remitente: ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ml-2",
                          staticStyle: { width: "calc(100% - 140px)" },
                        },
                        [
                          _c("input", {
                            staticClass:
                              "form-control form-control-sm text-muted bg-white",
                            staticStyle: {
                              "font-size": "11px",
                              height: "31px",
                              display: "flex",
                              "align-items": "center",
                            },
                            attrs: { type: "text", readonly: "" },
                            domProps: { value: _vm.data.shipper },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group mb-2 d-flex align-items-center",
                    },
                    [
                      _c(
                        "small",
                        {
                          staticClass: "input-title",
                          staticStyle: { width: "140px" },
                        },
                        [_vm._v("Peso: ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ml-2",
                          staticStyle: { width: "calc(100% - 140px)" },
                        },
                        [
                          _c("input", {
                            staticClass:
                              "form-control form-control-sm text-muted bg-white",
                            staticStyle: {
                              "font-size": "11px",
                              height: "31px",
                              display: "flex",
                              "align-items": "center",
                            },
                            attrs: { type: "text", readonly: "" },
                            domProps: {
                              value: Number(_vm.data.weight || 0).toFixed(2),
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group mb-2 d-flex align-items-center",
                    },
                    [
                      _c(
                        "small",
                        {
                          staticClass: "input-title",
                          staticStyle: { width: "140px" },
                        },
                        [_vm._v("Estado: ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ml-2",
                          staticStyle: { width: "calc(100% - 140px)" },
                        },
                        [
                          _c("input", {
                            staticClass:
                              "form-control form-control-sm text-muted bg-white",
                            staticStyle: {
                              "font-size": "11px",
                              height: "31px",
                              display: "flex",
                              "align-items": "center",
                            },
                            attrs: { type: "text", readonly: "" },
                            domProps: { value: _vm.data.state.name },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group mb-2 d-flex align-items-center",
                    },
                    [
                      _c(
                        "small",
                        {
                          staticClass: "input-title",
                          staticStyle: { width: "140px" },
                        },
                        [_vm._v("Descripción: ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ml-2",
                          staticStyle: { width: "calc(100% - 140px)" },
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "div",
                                        _vm._g(
                                          _vm._b({}, "div", attrs, false),
                                          on
                                        ),
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.data.description,
                                                expression: "data.description",
                                              },
                                            ],
                                            staticClass:
                                              "form-control form-control-sm text-muted bg-white",
                                            staticStyle: {
                                              "font-size": "11px",
                                              height: "31px",
                                              display: "flex",
                                              "align-items": "center",
                                            },
                                            attrs: {
                                              type: "text",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value: _vm.data.description,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.data,
                                                  "description",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "small",
                                _vm._l(
                                  _vm.data.description,
                                  function (description, key) {
                                    return _c("div", { key: key }, [
                                      _vm._v(_vm._s(description)),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group mb-2 d-flex align-items-center",
                    },
                    [
                      _c(
                        "small",
                        {
                          staticClass: "input-title",
                          staticStyle: { width: "140px" },
                        },
                        [_vm._v("Tracking: ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ml-2",
                          staticStyle: { width: "calc(100% - 140px)" },
                        },
                        [
                          _c("input", {
                            staticClass:
                              "form-control form-control-sm text-muted bg-white",
                            staticStyle: {
                              "font-size": "11px",
                              height: "31px",
                              display: "flex",
                              "align-items": "center",
                            },
                            attrs: { type: "text", readonly: "" },
                            domProps: { value: _vm.data.tracking },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group mb-2 d-flex align-items-center",
                    },
                    [
                      _c(
                        "small",
                        {
                          staticClass: "input-title",
                          staticStyle: { width: "140px" },
                        },
                        [_vm._v("Impuesto: ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ml-2",
                          staticStyle: { width: "calc(100% - 140px)" },
                        },
                        [
                          _c("input", {
                            staticClass:
                              "form-control form-control-sm text-muted bg-white",
                            staticStyle: {
                              "font-size": "11px",
                              height: "31px",
                              display: "flex",
                              "align-items": "center",
                            },
                            attrs: { type: "text", readonly: "" },
                            domProps: {
                              value: _vm.data.tax
                                ? Number(_vm.data.tax.value * 100 || 0).toFixed(
                                    2
                                  ) + "%"
                                : "",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group mb-2 d-flex align-items-center",
                    },
                    [
                      _c(
                        "small",
                        {
                          staticClass: "input-title",
                          staticStyle: { width: "140px" },
                        },
                        [_vm._v("Creado: ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ml-2",
                          staticStyle: { width: "calc(100% - 140px)" },
                        },
                        [
                          _c("input", {
                            staticClass:
                              "form-control form-control-sm text-muted bg-white",
                            staticStyle: {
                              "font-size": "11px",
                              height: "31px",
                              display: "flex",
                              "align-items": "center",
                            },
                            attrs: { type: "text", readonly: "" },
                            domProps: {
                              value: _vm._f("DATE")(_vm.data.created_at),
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.data.exemption
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "form-group mb-2 d-flex align-items-center",
                        },
                        [
                          _c(
                            "small",
                            {
                              staticClass: "input-title",
                              staticStyle: { width: "140px" },
                            },
                            [_vm._v("Estado de ExenciónSolicitada: ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ml-2",
                              staticStyle: { width: "calc(100% - 140px)" },
                            },
                            [
                              _c("input", {
                                staticClass:
                                  "form-control form-control-sm text-muted bg-white",
                                staticStyle: {
                                  "font-size": "11px",
                                  height: "31px",
                                  display: "flex",
                                  "align-items": "center",
                                },
                                attrs: { type: "text", readonly: "" },
                                domProps: {
                                  value: _vm._f("EXEMPTION")(
                                    _vm.data.exemption
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Archivos Adjuntos: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [_c("div", { staticClass: "py-3" })]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      _vm._l(_vm.data.files, function (item, index) {
                        return _c(
                          "div",
                          { staticClass: "col-md-2 col-sm-3 col-4" },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "" + item.path,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                              },
                              [
                                item.type != "pdf"
                                  ? _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: { src: "" + item.path },
                                    })
                                  : _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: { src: _vm.pdf },
                                    }),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _vm.data.invoice
                          ? _c("billing", { attrs: { print: false } })
                          : _c("div", [
                              _vm._v("Su paquete aun no cuenta con factura"),
                            ]),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }